import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["control", "tab"]

  select(e) {
    e.stopPropagation()
    e.preventDefault()
    const selectedTab = e.target.dataset.tab

    for (const tab of this.tabTargets) {
      tab.style.display = "none"
      if (tab.dataset.tab === selectedTab) {
        tab.style.display = ""
      }
    }

    for (const control of this.controlTargets) {
      control.classList.remove("active")
      if (control.dataset.tab === selectedTab) {
        control.classList.add("active")
      }
    }
  }
}
